const compatModules = {};import * as Mod1 from "./discourse/connectors/group-edit/external-controlled-groups.gjs";
compatModules["discourse/connectors/group-edit/external-controlled-groups"] = Mod1;

export * as discourse$connectors$group__edit$external__controlled__groups$$__module from "./discourse/connectors/group-edit/external-controlled-groups.gjs";
export {
default as discourse$connectors$group__edit$external__controlled__groups$$default
} from "./discourse/connectors/group-edit/external-controlled-groups.gjs";
import * as Mod2 from "./discourse/initializers/waze-external-controlled-groups";
compatModules["discourse/initializers/waze-external-controlled-groups"] = Mod2;

export * as discourse$initializers$waze__external__controlled__groups$$__module from "./discourse/initializers/waze-external-controlled-groups";
export {
default as discourse$initializers$waze__external__controlled__groups$$default
} from "./discourse/initializers/waze-external-controlled-groups";
export default compatModules;
